import { render, staticRenderFns } from "./HeaderPanel.vue?vue&type=template&id=088f3370&scoped=true"
import script from "./HeaderPanel.vue?vue&type=script&lang=js"
export * from "./HeaderPanel.vue?vue&type=script&lang=js"
import style0 from "./HeaderPanel.vue?vue&type=style&index=0&id=088f3370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f3370",
  null
  
)

export default component.exports